import { bartStore } from "@/store/bartStore";
import type { BARTModule, BARTModuleConfig } from "@/ts/module";
import { appendHtmlToHead } from "@/utils/dom";
const loadScript = (scriptTag: string, callback: () => void) => {
    const SCRIPT_TAG = `<script type="text/javascript" src=${scriptTag} defer></script>`;
    appendHtmlToHead(SCRIPT_TAG, callback);
};
const initBART = (siteOverrideId: bigint) => {
    !!window.__adVerification &&
        window.__adVerification.init(5293, siteOverrideId);
};
const loadBART = (scriptURL: string, callback: () => void) => {
    // cachebuster rolls over every Monday 10am UTC
    const prevMonday = new Date();
    prevMonday.setUTCDate(prevMonday.getUTCDate() - ((prevMonday.getUTCDay() + 6) % 7));
    prevMonday.setUTCHours(10, 0, 0, 0);
    const cachebuster = `?cb=${Math.floor(prevMonday.getTime()) / 1000}`;
    loadScript(`${scriptURL}${cachebuster}`, callback);
};
export class BART implements BARTModule {
    private config: BARTModuleConfig;
    name = "BART" as const;
    constructor(config: BARTModuleConfig) {
        this.config = config;
    }
    async init(): Promise<void> {
        const bartConfig = this.config;
        if (bartConfig) {
            bartStore.setState(bartConfig);
            const { scriptURL, siteId } = bartStore.getState();
            const siteOverrideId: bigint = BigInt(siteId);
            if (window.__adVerification) {
                initBART(siteOverrideId);
            }
            else {
                loadBART(scriptURL, () => initBART(siteOverrideId));
            }
        }
    }
}
